export default "__VITE_ASSET__KJC40hmA__"